module.exports = __webpack_public_path__ + "static/img/cardBackground.276048e5.png";